import { Trans, useTranslation } from 'react-i18next'

const B2becTranslation = ({
  value: key,
  variables = {},
  isComponent = false,
  htmlTags = [],
  context = '',
}) => {
  const { t } = useTranslation()

  /**
   * value/key  : id for the translatable texts, rename to 'key' to avoid confusion
   * variables  : an object contains dynamic variables in the translatable texts
   * isComponent: a boolean flag distinguish translatable texts interpolate html tags
   * htmlTags   : an array of html tags to interpolate based on index of tag <0></0>, ...
   */

  return isComponent
    ? (
      <Trans
        components={htmlTags}
        context={context}
        i18nKey={key}
        values={variables}
      />
    )
    : <span>{t(key, variables)}</span>
}

export default B2becTranslation
